import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '@fuse/services/config.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { MatAutocompleteSelectedEvent, MatDialog, MatOption, MatSelect, MatStepper } from '@angular/material';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'app/shared/common/helper/http-service';
import { Configuration } from 'app/app.configuration';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ProfilehelperDD } from 'app/shared/common/helper/personaldetails-helper';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { ScrumboardService } from '../../scrumboard/scrumboard.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { NgxSpinnerService } from 'ngx-spinner';
import { CountryISO, SearchCountryField, TooltipLabel } from 'ngx-intl-tel-input';

export interface inviteppl {
  name: string;
}

@Component({
  selector: 'app-onboard',
  templateUrl: './onboard.component.html',
  styleUrls: ['./onboard.component.scss']
})
export class OnboardComponent implements OnInit {
  newId: any;
  isLinear = false;
  formfirstStep: FormGroup;
  formSecondStep: FormGroup;
  formThirdStep: FormGroup;
  @ViewChild("helperPop", { static: false }) helperPop: TemplateRef<any>;
  @ViewChild('desktopAppSetting', { static: false }) desktopSetting: TemplateRef<any>;
  roleId: any;
  departmentList = [];
  roleList = [];
  reportingtoList = [];
  reportList = [];
  profileId: any;
  organisationLists = [];
  customTask: any;
  isCompleted = false;
  state: string;
  userNameFromOnboarding: string;

  company_name;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  payload: any;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  invitePplCtrl = new FormControl();
  filteredinvitePpls: Observable<string[]>;
  invitePpls: any = [];
  allinvitePpls: string[] = [];
  properMailID = false;
  adminPatchValue: any;
  getAdminValue = [];
  selectedProject: any;
  projectId: any;
  nextStepActive: boolean = false;
  // test: string;
  hide = true;
  conformationPassword: Boolean = true;
  userNameInInvite: any;
  dynamicForm: FormGroup;
  softwareEngineerRoleId: any;
  tenantId: any;
  firstNameValueAdmin: any;
  profileUserName: '';
  adminUserName: string;
  invitedUserEmail: string;
  invitedUserName: string;
  invitedUserId: string;
  InvitedUserDetials = [];
  assignProjectToUser: boolean = true;
  profileDetails: any;
  unassingedProjectDetails: any;
  // locationId: string;
  locationId: string;
  organizationId: string;
  departmentId: string;
  invitedProfileId: string;
  clientId: string;
  invitedUsers: string;
  billingTypeHelp = false;
  billingHelperText: any;
  defaultSprintId: any;
  helperPopup = false;
  defaultprojectId: string;
  registeredDate: any;
  extendedExpiringDateCount: any;
  trailExpiryDateCount: any;
  sourceFrom: any;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  submitted: boolean;
  @ViewChild('others', { static: false }) industryName: ElementRef;
  profileDetail: any;
  scrumBoardId: any;
  industryDepartmentName: any;

  constructor(private storageConfiguration: StorageConfiguration, private route: ActivatedRoute, private _scrumboardService: ScrumboardService,
    private dateConvertor: DateConvertor, private _helper: ProfilehelperDD, private queryInterface: QueryInterface,
    private dataService: DataService, private router: Router, private fb: FormBuilder,
    public parseService: ParseService, private _fuseConfigService: FuseConfigService, private toastr: ToastrService,
    private configuration: Configuration,
    private spinner: NgxSpinnerService, public dialog: MatDialog) {
    this.createForm();
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };
  }
  @ViewChild('select', { static: false }) select: MatSelect;
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  allSelected = false;
  customTasks: any[] = [
    { defaulttask: 'Project Management', viewValue: 'Project Management' },
    { defaulttask: 'Client Meeting', viewValue: 'Client Meeting' },
    { defaulttask: 'Internal Meeting', viewValue: 'Internal Meeting' },
    { defaulttask: 'Huddle', viewValue: 'Huddle' },
  ];

  industry: any[] = [];

  async getIndustry(): Promise<void> {
    this.industry = [];
    const Industry = this.parseService.instance.Object.extend('Industry');
    const industryQuery = new this.parseService.instance.Query(Industry);
    industryQuery.limit(10000);
    const industryData = await industryQuery.find();
    // console.log('industryData', industryData);
    industryData.forEach((industry => {
      const name = industry.get('name');
      const id = industry.id;
      this.industry.push({ id, industry: name, industryviewValue: name });
    }));
  }

  async ngOnInit() {
    await this.getRoles();
    this.route.queryParams.subscribe(async params => {
      this.adminPatchValue = params.id;
      this.getAdminDefaultValue();
    }
    );
    this.allSelected = true;
    this.seedFiltersFormArray();
    this.getIndustry();
    this.getDepartment();
  }

  /**
   * * Create a Industry role for the tenant in the tenant_role table
   * @input (industry Id)
   */
  async createIndustryRoles(industryId): Promise<void> {

    /**
     * * fetch the industry roles for the selected industry
     */
    const IndustryRoleClass = this.parseService.instance.Object.extend('IndustryRole');
    const industryRoleQuery = new this.parseService.instance.Query(IndustryRoleClass);
    industryRoleQuery.include('masterRoleIds');
    industryRoleQuery.include('roleIds');
    industryRoleQuery.equalTo('industryId', {
      __type: 'Pointer',
      className: 'Industry',
      objectId: industryId,
    });
    const industryRoleData = await industryRoleQuery.find();

    /**
     * *get the Industry roles mapped to the Industry_role table
     */
    const industryRoleIds = industryRoleData[0].get('roleIds');
    const industryRoles = await industryRoleIds.query().find();
    const industryRolesJSON = JSON.parse(industryRoleData[0].get('displayName'));

    const industryDepartmentName = industryRoleData[0].get('departmentNames');
    this.industryDepartmentName = industryDepartmentName;


    /** 
     * *Create a tenant role for the tenant
     */
    for (const industryRole of industryRoles) {
      /**
       * * get display_name for the role form the industry_role table
       */
      // const displayNames = Object.keys(industryRolesJSON).
      //   filter((key) => key.includes(industryRole.get('name'))).
      //   reduce((cur, key) => Object.assign(cur, { [key]: industryRolesJSON[key] }), {});
      if (industryRolesJSON[industryRole.get('name')] != undefined) {
        const TenantRoleClass = this.parseService.instance.Object.extend('TenantRole');
        const tenantRoleClass = new TenantRoleClass();
        tenantRoleClass.set('tenantId', this.tenantId);
        tenantRoleClass.set('name', industryRole.get('name'));
        tenantRoleClass.set('displayName', industryRolesJSON[industryRole.get('name')]);
        tenantRoleClass.set('reportingTo', industryRole.get('reportingTo'));
        tenantRoleClass.set('isActive', industryRole.get('isActive'));
        tenantRoleClass.set('role', { __type: 'Pointer', className: '_Role', objectId: industryRole.id });
        tenantRoleClass.set('ACL', industryRole.get('ACL'));
        const tenantRoleResult = await tenantRoleClass.save();
      }
    }
  }

  help(): void {
    this.billingTypeHelp = true;
  }

  onChangeBillingType(selectedBilling): void {
    this.billingHelperText = selectedBilling;
  }

  seedFiltersFormArray() {
    this.customTasks.forEach(seedDatum => {
      const formGroup = this.createFilterGroup();
      // if (seedDatum.apiType) {
      formGroup.addControl('defaulttask', this.getFormControl());
      // }
      formGroup.patchValue(seedDatum);
      this.filtersFormArray.push(formGroup);
    });
  }
  helperTextPopup() {
    this.dialog.open(this.helperPop, {
      width: "500px"
    });
  }
  desktopSettingPopup(): void {
    this.dialog.open(this.desktopSetting, {
      width: '500px'
    });
  }
  closehelperTextPopup() {
    this.dialog.closeAll();
  }


  createFilterGroup() {
    return this.fb.group({
      defaulttask: []
    });
  }

  addFilterToFiltersFormArray() {
    this.filtersFormArray.push(this.createFilterGroup());
  }

  removeFilterFromFiltersFormArray(index) {
    this.filtersFormArray.removeAt(index);
  }

  selectedAPIChanged(i) {
    this.getFilterGroupAtIndex(i).addControl('defaulttask', this.getFormControl());
  }

  getFormControl() {
    return this.fb.control(null);
  }


  get filtersFormArray() {
    return (<FormArray>this.formThirdStep.get('filters'));
  }

  getFilterGroupAtIndex(index) {
    return (<FormGroup>this.filtersFormArray.at(index));
  }
  // emd
  optionClick() {
    let newStatus = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelected = newStatus;
  }
  selectedValue: string;
  selectedbillableValue: string;

  private validateEmail(email) {
    var returnValue = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return returnValue.test(String(email).toLowerCase());
  }

  async add(event: MatChipInputEvent) {

    const isInvitedEmail = this.invitePpls.filter((o1) => {
      return o1.email === event.value.trim().toLowerCase() ? true : false; // return the ones with equal id
    });
    if (isInvitedEmail.length > 0) {
      this.toastr.error('Email already exists');
      return;
    }
    const isEmailExits = await this.checkEmailAlreadyExist(event.value.trim().toLowerCase());
    if (isEmailExits) {
      this.toastr.error('Email already exists');
      return;
      // throw new Error('Email already exists');
    }
    if (event.value) {
      if (this.validateEmail(event.value)) {
        this.properMailID = false;
        const obj = {
          'email': event.value.trim().toLowerCase(),
          'isWebDesktop': false,
        };
        this.invitePpls.push(obj);
      } else {
        this.properMailID = true;
        this.formSecondStep.controls['invitePeople'].setErrors({ 'incorrectEmail': true });
        return false;
      }
    }
    if (event.input) {
      event.input.value = '';
    }
  }

  async sendInviteMemberEmail() {
    // let memberinviteData = this.invitePpls;
    const invitedMemberEmail = [];
    this.invitePpls.filter((user) => {
      invitedMemberEmail.push(user.email);
    });
    this.dataService.add(this.configuration.inviteMembers + '?tenantId=' + this.tenantId + '&profileId=' + this.profileId + '&projectId=' + this.projectId, invitedMemberEmail).subscribe((data: any) => { }, error => {
      // console.log('error', error)
    });
  }

  remove(invitePpl: string): void {
    const index = this.invitePpls.indexOf(invitePpl);

    if (index >= 0) {
      this.invitePpls.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.invitePpls.push(event.option.viewValue);
    this.invitePplCtrl.setValue(null);
  }


  billables = [
    { id: 'Time and Material Billable', Billable: 'Time and Material Billable ' },
    { id: 'Time and Material Non-Billable', Billable: 'Time and Material Non-Billable', },
    { id: 'Fixed Billable', Billable: 'Fixed Billable ' },
    { id: 'Fixed Non-Billable', Billable: 'Fixed Non-Billable ' }
  ];

  createForm() {
    this.formfirstStep = this.fb.group({
      firstName: [''],
      lastName: [''],
      email: ['', Validators.required],
      password: ['', [Validators.required]],
      confirm_password: ['', [Validators.required]],
      industry: ['', Validators.required],
      roleId: ['', Validators.required],
      mobileNumber: [''],
      invitePeople: [''],
      isWebDesktop: [true]
    }, {
      validators: this.password.bind(this)
    });

    this.formThirdStep = this.fb.group({
      projectName: ['', Validators.required],
      projectType: ['', Validators.required],
      isAssigned: [true],
      // projectDescription: ['', Validators.required],
      // defaulttask: ['', Validators.required],
      filters: this.fb.array([]),
      taskValue: [''],
    });
  }

  password(formGroup: FormGroup) {
    const { value: password } = formGroup.get('password');
    const { value: confirmPassword } = formGroup.get('confirm_password');
    return password === confirmPassword ? null : { passwordNotMatch: true };
  }
  async createCustomer(): Promise<void> {
    const registerDate1 = new Date(this.registeredDate);
    const trailExpiryDate = new Date(registerDate1.setDate(registerDate1.getDate() + this.trailExpiryDateCount));
    const registerDate2 = new Date(this.registeredDate);
    const trailExpiryDateCopy = new Date(registerDate2.setDate(registerDate2.getDate() + this.trailExpiryDateCount));
    const extendedExpiringDate = new Date(trailExpiryDateCopy.setDate(trailExpiryDateCopy.getDate() + this.extendedExpiringDateCount));
    const Customer = this.parseService.instance.Object.extend('Customer');
    const customerClass = new Customer();
    customerClass.set('tenantId', this.tenantId);
    customerClass.set('sourceFrom', this.sourceFrom);
    customerClass.set('registerDate', this.registeredDate);
    customerClass.set('trailExpiryDate', trailExpiryDate);
    customerClass.set('extendedExpiringDate', extendedExpiringDate);
    customerClass.set('contact', this.formfirstStep.value.mobileNumber);
    customerClass.set('isBlock', false);
    customerClass.set('customerOnboarding', { __type: 'Pointer', className: 'CustomerOnBoarding', objectId: this.adminPatchValue });
    await customerClass.save().then(() => { });
  }

  async getExpiryDate(): Promise<void> {
    const DataSettings = this.parseService.instance.Object.extend('DataSettings');
    const dataSettingsQuery = new this.parseService.instance.Query(DataSettings);
    let dataSettingResult = await dataSettingsQuery.find();
    dataSettingResult = await dataSettingResult[0];
    this.trailExpiryDateCount = dataSettingResult.get('trailExpiryDate');
    this.extendedExpiringDateCount = dataSettingResult.get('extendedExpiringDate');
  }

  async formCreateAdmins() {
    this.spinner.show();
    var nameFirst = this.formfirstStep.value.firstName
    var nameLast = this.formfirstStep.value.lastName
    var userName = nameFirst.concat(' ' + nameLast);

    let email = this.parseService.instance.Object.extend('_User');
    let emailQuery = new this.parseService.instance.Query(email);
    emailQuery.equalTo('email', this.formfirstStep.value.email);
    let result = await emailQuery.find();
    if (result.length > 0) {
      this.toastr.warning('Account already exists for this email address.');
      return false;
    }
    await this.addClient();
    let profile = this.parseService.instance.Object.extend('Profile');
    let createQuery = new profile();
    var role = new this.parseService.instance.Object('_Role');
    role.id = this.formfirstStep.value.roleId.id;
    this.roleId = role.id;
    createQuery.set('role', role);
    var roleHistory = [];
    var currentRole = this.roleList.filter(
      role => role.id == this.formfirstStep.value.roleId.id
    );
    let roleHistoryInfo = {
      id: this.formfirstStep.value.roleId.id,
      name: currentRole[0].name,
      startDate: new Date(),
      endDate: '',
      isActive: true
    };
    roleHistory.push(roleHistoryInfo);
    createQuery.set('roleHistory', roleHistory);
    const department = new this.parseService.instance.Object('Department');
    department.id = this.departmentList[0].objectId;
    createQuery.set('location', { __type: 'Pointer', className: 'Location', objectId: this.locationId });
    createQuery.set('organisation', { __type: 'Pointer', className: 'Organisation', objectId: this.organizationId });
    createQuery.set('department', department);
    createQuery.set('firstName', nameFirst);
    createQuery.set('lastName', nameLast);
    createQuery.set('username', userName);
    createQuery.set('email', this.formfirstStep.value.email);
    createQuery.set('password', this.formfirstStep.value.password);
    createQuery.set('isActive', true);
    createQuery.set('isLongLeave', false);
    createQuery.set('departmentHistory', []);
    createQuery.set('locationHistory', []);
    createQuery.set('organisationHistory', []);
    createQuery.set('reporterHistory', []);
    createQuery.set('personalInfo', { 'mobileNo': this.formfirstStep.value.mobileNumber });
    createQuery.set('skillSet', []);
    createQuery.set('resignationInfo', {});
    createQuery.set('profileImageInfo', {});
    createQuery.set('officialInfo', { 'startTime': '9:30 AM', 'officialEmail': this.formfirstStep.value.email });
    createQuery.set('systemInfo', {});
    createQuery.set('experienceInfo', []);
    createQuery.set('userStatus', 'Away');
    createQuery.set('status', 'Active');
    createQuery.set('isWebDesktop', this.formfirstStep.value.isWebDesktop);
    createQuery.set('screenShot', true);
    createQuery.set('tenantId', this.tenantId);
    createQuery.set('screenShotSyncTime', 300);
    localStorage.clear();
    sessionStorage.clear();
    createQuery.save().then(async (data) => {
      this.profileId = data.id;
      this.profileDetail = data;
      createQuery.set('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: data.id });
      createQuery.save().then(async (value: any) => {
        this.updateIndustryName();
        // if (this.formfirstStep.value.industry.industry == 'BPO') {
        await this.createDepartment(data.id);
        // }
        await this.createUser();
        await this.createProject();
        await this.createDefaultProject();
        await this.createCustomAccess(this.profileId);
        await this.sendRegisterAccountEmail(data);
        await this.sendInviteMemberEmail();
        await this.invitedUser();
        await this.autologin();
        this.spinner.hide();
      });
    }).catch((error) => {
      this.spinner.hide();
      if (error.message === 'Account already exists for this username.') {
        this.toastr.error('Account already exists for this username.');
        return false;
      } else if (error.message === 'Account already exists for this email address.') {
        this.toastr.error('Account already exists for this email address.');
        return false;
      }
    });
  }

  // check email already exists
  async checkEmailAlreadyExist(email): Promise<Boolean> {
    if (this.formfirstStep.value.email == email) return true;  /** Check onboard email Id is used in Invited members **/
    const User = this.parseService.instance.Object.extend('_User');
    const userQuery = new this.parseService.instance.Query(User);
    userQuery.equalTo('email', email);
    const res = await userQuery.find();
    const userData = res[0];
    if (userData !== undefined) {
      this.toastr.error('Email Already Exist.');
      this.spinner.hide();
      return true;
    }
    return false;
  }

  async createDepartment(adminProfileId) {
    const departments = this.industryDepartmentName; // get department display name based on industry name
    const departmentList = this.departmentList; // total department list
    let index = 0;
    for (const department of departments) {
      if (departmentList[index] != undefined) {
        const objectId = departmentList[index].objectId ? departmentList[index].objectId : ''
        const TenantDepartment = this.parseService.instance.Object.extend('TenantDepartment');
        const createQuery = new TenantDepartment();
        createQuery.set('tenantId', this.tenantId);
        createQuery.set('industry', { __type: 'Pointer', className: 'Industry', objectId: this.formfirstStep.value.industry.id });
        createQuery.set('department', { __type: 'Pointer', className: 'Department', objectId: objectId });
        createQuery.set('displayName', department);
        await createQuery.save();
        index++;
      }
    }

  }

  async createProject() {
    const profileValues = this.formThirdStep.value;
    const resourceDetails = {
      id: this.getRandomNumber(9),
      details: [

      ],
      resourceDetailDate: new Date()
    };
    const data = {
      projectInfo: {
        clientName: this.clientId,
        projectDescription: "",
        projectName: profileValues.projectName,
        // projectType: profileValues.projectType,
        addOnType: profileValues.addOnType,
        projectType: profileValues.addOnType == 'Support' || profileValues.addOnType == 'Task' ? '' : profileValues.projectType,
        currentStatus: 'New',
        projectPlatform: ["NodeJs", "Php", "Angular", "Angularjs", "AWS"],
        reason: '',
        projectStartDate: this.dateConvertor.addGMTOffset(new Date()).toISOString(),
        actualCompletionDate: "",
        extendedCompletionDate: "",
        srs: [],
        plan: [],
      },
      resourceDetails: resourceDetails
    };


    const ProjectClass = this.parseService.instance.Object.extend('Project');
    var projectDetails = new ProjectClass();
    projectDetails.set('projectInfo', data.projectInfo);
    projectDetails.set('client', { __type: 'Pointer', className: 'Client', objectId: this.clientId });
    projectDetails.set('comments', []);
    projectDetails.set('projectType', 'Project');
    projectDetails.set('isActive', true);
    projectDetails.set('resourceDetails', resourceDetails);
    projectDetails.set('defaultProject', false);
    // projectDetails.set('activities', activities);
    projectDetails.set('tenantId', this.tenantId);
    if (profileValues.projectType == 'Fixed Billable') {
      projectDetails.set('schedulerStatus', 'Fixed Billable');
    }
    else if (profileValues.projectType == 'Fixed Non-Billable') {
      projectDetails.set('schedulerStatus', 'Fixed Non-Billable');
    }
    else if (profileValues.projectType == 'Time and Material Billable') {
      projectDetails.set('schedulerStatus', 'Time and Material Billable');
    }
    else if (profileValues.projectType == 'Time and Material Non-Billable') {
      projectDetails.set('schedulerStatus', 'Time and Material Non-Billable');
    }
    else {
      projectDetails.set('schedulerStatus', '');
    }
    let res = await projectDetails.save();
    this.projectId = res.id;
    this.profileDetails = res;
    await this._scrumboardService.createScrumBoard(this.projectId, false).then(async data => {
      this.defaultSprintId = data.id;
      this.scrumBoardId = await this.getScrumBoardId();
      await this.saveDefaultTasks(this.filtersFormArray.value, this.scrumBoardId, this.defaultSprintId);
      await this.saveDefaultTask();
      await this.assignProject(res);
    });
  }

  async getScrumBoardId() {
    let ProjectBoardLists = this.parseService.instance.Object.extend('ProjectBoardLists');
    let projectBoardLists = new this.parseService.instance.Query(ProjectBoardLists);
    projectBoardLists.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    projectBoardLists.equalTo('name', 'Backlogs');
    let projectBoardDetails = await projectBoardLists.find();
    if (projectBoardDetails.length > 0) {
      return projectBoardDetails[0].id;
    }
  }

  saveDefaultTask() {
    const DefaultTask = this.parseService.instance.Object.extend('DefaultTaskList');
    var defaultTask = new DefaultTask();
    defaultTask.set('tenantId', this.tenantId);
    defaultTask.set('defaultTasks', this.filtersFormArray.value);
    defaultTask.save();
  }

  // Create default project in onboard stepper(unassinged)
  async createDefaultProject() {

    const resourceDetails = {
      id: this.getRandomNumber(9),
      details: [
      ],
      resourceDetailDate: new Date()
    };

    const data = {
      projectInfo: {
        clientName: this.clientId,
        projectDescription: "",
        projectType: "Fixed Non-Billable",
        projectName: 'Unassigned Project',
        // addOnType: profileValues.addOnType,
        currentStatus: 'New',
        projectPlatform: [],
        reason: '',
        projectStartDate: this.dateConvertor.addGMTOffset(new Date()).toISOString(),
        actualCompletionDate: this.dateConvertor.addGMTOffset(new Date()).toISOString(),
        extendedCompletionDate: this.dateConvertor.addGMTOffset(new Date()).toISOString()
      },
      resourceDetails: resourceDetails
    };
    const projectNew = this.parseService.instance.Object.extend('Project');
    var defaultProjectDetails = new projectNew();
    defaultProjectDetails.set('projectInfo', data.projectInfo);
    defaultProjectDetails.set('client', { __type: 'Pointer', className: 'Client', objectId: this.clientId });
    defaultProjectDetails.set('comments', []);
    defaultProjectDetails.set('projectType', 'Project');
    defaultProjectDetails.set('isActive', true);
    defaultProjectDetails.set('resourceDetails', resourceDetails);
    defaultProjectDetails.set('defaultProject', true);
    defaultProjectDetails.set('tenantId', this.tenantId);
    defaultProjectDetails.set('schedulerStatus', 'Fixed Non-Billable');
    let res = await defaultProjectDetails.save();
    this.defaultprojectId = res.id;
    this.unassingedProjectDetails = res;
    this.assignProject(res);
    this._scrumboardService.createScrumBoard(this.defaultprojectId, false).then(data => {
      this.defaultSprintId = data.id;
    });
  }


  AssignedProject(data) {
    this.assignProjectToUser = data.checked;
  }

  sendRegisterAccountEmail(result) {
    let data = {
      name: result.get('firstName') + ' ' + result.get('lastName'),
      email: result.get('officialInfo').officialEmail,
      password: this.formfirstStep.value.password
    }
    this.dataService.add(this.configuration.registerAccount, data).subscribe((data: any) => {
    });
  }


  async createCustomAccess(profileId) {

    let CustomRoleSettings = this.parseService.instance.Object.extend('CustomRoleSettings');
    let createQuery = new CustomRoleSettings();
    createQuery.set('tenantId', this.tenantId);
    createQuery.set('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId });
    let adminSettings = [
      {
        moduleName: "Employees",
        All: true,
        Assigned: false,
        None: false,
      },
      {
        moduleName: "Projects",
        All: true,
        Assigned: false,
        None: false,
      }
    ]
    createQuery.set('customRoles', adminSettings);
    let data = await createQuery.save();
  }

  createUser() {
    var nameFirst = this.formfirstStep.value.firstName
    var nameLast = this.formfirstStep.value.lastName
    var userName = nameFirst.concat(' ' + nameLast);
    let user = this.parseService.instance.Object.extend('User');
    let createQuery = new user();
    let profile = this.parseService.instance.Object.extend('Profile');
    let profileClass = new profile();
    profileClass.id = this.profileId;
    createQuery.set('profile', profileClass);
    createQuery.set('firstName', nameFirst);
    createQuery.set('lastName', nameLast);
    createQuery.set('username', userName);
    createQuery.set('email', this.formfirstStep.value.email);
    createQuery.set('password', this.formfirstStep.value.password);
    createQuery.set('isActive', true);
    createQuery.set('employeeId', '');
    createQuery.set('tenantId', this.tenantId);
    createQuery.set('role', { __type: 'Pointer', className: '_Role', objectId: 'vFcHQmBI4A' });
    createQuery.signUp().then((data) => {
      this.storageConfiguration.sessionSetItem(this.storageConfiguration.industryId, this.formfirstStep.value.industry.id);
      // this.toastr.success("Login successfully")
      this.newId = data.id;
      this.profileUserName = data.attributes.username;
      this.isCompleted = true;
      this.state = 'done';
      this.addUsertoRoleNamed();
      this.stepper.next();
    }).catch((error) => {
      if (error.message === 'Account already exists for this username.') {
        this.toastr.error('Account already exists for this username.');
      } else if (error.message === 'Account already exists for this email address.') {
        this.toastr.error('Account already exists for this email address.');
      }
    });
  }
  goNextStep(stepper: MatStepper) {
    stepper.next();

  }
  goMove(stepper: MatStepper) {
    if (this.formfirstStep.invalid) {
      if (this.formfirstStep.controls['mobileNumber'].invalid) {
        this.toastr.error('Enter the valid mobile number');
      }
      this.submitted = true;
      return;
    }
    stepper.next();
    this.nextStepActive = true;
  }
  backpage() {
    this.nextStepActive = false;
  }

  goForward(stepper: MatStepper) {
    this.stepper.next();

  }

  async getRoles() {
    let rolesClass = this.parseService.instance.Object.extend('_Role');
    let roleQuery = new this.parseService.instance.Query(rolesClass);
    roleQuery.equalTo('isActive', true);
    roleQuery.ascending('name');
    await roleQuery.find().then(results => {
      results.forEach(element => {
        var roleId = element.id;
        var roleName = element.get('name');
        this.roleList.push({ id: roleId, name: roleName });
      });
    });
  }

  async designation(event) {
    if (event.value.name == 'CEO' || event.value.name == 'General Manager' || event.value.name == 'HR' || event.value.name == 'Admin') {
      this.reportingtoList = this.reportingtoList.filter(x => x.role == 'CEO');
    } else {
      this.reportingtoList = this._helper.reportingtoEmployee;
      // this.getReportingTo();
    }
  }

  async addUsertoRoleNamed() {
    var queryRel = new this.parseService.instance.Query('User');
    queryRel.equalTo('objectId', this.newId);
    await queryRel.find().then(users => {
      var user = users[0];
      this.addRelation(user).then(res => {

      });
    }).then((error) => {

    })
  }


  async addRelation(user) {
    var queryRel = new this.parseService.instance.Query('_Role');
    queryRel.equalTo('objectId', this.roleId);
    await queryRel.first().then((role) => {
      var relation = role.relation('users');
      relation.add(user);
      role.save().then((result) => {
      });
      return role;
    });
  }
  getRandomNumber(val) {
    const timestamp = +new Date();
    length = val;
    var ts = timestamp.toString();
    var parts = ts.split('').reverse();
    var id = '';

    for (var i = 0; i < length; ++i) {
      var index = this.generateRandomNumber(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }

  generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  spaces(x) {
    var res = '';
    while (x--) res += ' ';
    return res;
  }

  async updateIndustryName(): Promise<void> {
    const CustomerOnBoarding = this.parseService.instance.Object.extend('CustomerOnBoarding');
    const customerOnBoardingQuery = new this.parseService.instance.Query(CustomerOnBoarding);
    customerOnBoardingQuery.equalTo('objectId', this.adminPatchValue);
    let CustomerOnBoardingResult = await customerOnBoardingQuery.find();
    CustomerOnBoardingResult = CustomerOnBoardingResult[0];
    if (this.formfirstStep.value.industry.industry === 'Others') {
      CustomerOnBoardingResult.set('industryName', this.industryName.nativeElement.value);
    } else {
      CustomerOnBoardingResult.set('industryName', this.formfirstStep.value.industry.industry);
    }
    CustomerOnBoardingResult.set('industry', { __type: 'Pointer', className: 'Industry', objectId: this.formfirstStep.value.industry.id });
    CustomerOnBoardingResult.set('isOnBoardCompleted', true);
    CustomerOnBoardingResult.save().then(() => {
      // this.toastr.success('CustomerOnBoarding updated successfully');
    }).catch(() => {
      this.toastr.error('CustomerOnBoarding updated failed');
    });

  }

  async getAdminDefaultValue() {
    let queryInstance = this.parseService.instance.Object.extend('CustomerOnBoarding');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', this.adminPatchValue);
    let userId = await query.find();
    if (userId.length > 0) {
      if (userId[0].get('isOnBoardCompleted') === true) {
        this.router.navigate(['/login']);
        return;
      }
    }
    let emailValueAdmin = userId[0].get('email');
    this.firstNameValueAdmin = userId[0].get('firstName');
    let lastNameValueAdmin = userId[0].get('lastName');
    this.tenantId = userId[0].get('tenantId');
    this.registeredDate = userId[0].get('createdAt');
    this.sourceFrom = userId[0].get('sourceFrom');
    let rolesID = this.roleList.find(x => x.name == 'Admin');
    this.softwareEngineerRoleId = this.roleList.find(x => x.name == 'Software Engineer');
    this.userNameFromOnboarding = "Welcome" + this.spaces(4) + this.firstNameValueAdmin + this.spaces(4) + lastNameValueAdmin;
    this.formfirstStep.patchValue({
      firstName: this.firstNameValueAdmin,
      lastName: lastNameValueAdmin,
      email: emailValueAdmin,
      roleId: rolesID
    });
  }

  async formCreateProject() {
    if (this.formThirdStep.invalid) {
      return;
    }
    this.spinner.show();
    await this.addLocation();
    await this.addOrganization();
    await this.createIndustryRoles(this.formfirstStep.value.industry.id);
    this.formCreateAdmins();
  }

  autologin() {
    this.payload = {
      userEmail: this.formfirstStep.value.email,
      password: this.formfirstStep.value.password
    };

    const loginResult = this.parseService.instance.User.logIn(this.payload.userEmail, this.payload.password);
    loginResult.then(async res => {
      const myObject = JSON.parse(JSON.stringify(res));
      this.storageConfiguration.sessionSetItem(this.storageConfiguration.sessiontoken, myObject.sessionToken);

      this.storageConfiguration.sessionSetItem(this.storageConfiguration.isloggedIn, 'true');
      this.storageConfiguration.sessionSetItem(this.storageConfiguration.role, 'Admin');
      this.storageConfiguration.sessionSetItem(this.storageConfiguration.tenantId, myObject.tenantId);
      localStorage.setItem('loginType', 'Marketing');
      this.toastr.success('Login Successfully');
      this.router.navigate(['/onboarding']);
      await this.getExpiryDate();
      this.createCustomer();
    }, error => {
      this.toastr.error('Invalid username / password.');
    });
  }


  async saveDefaultTasks(taskList, scrumBoardId, defaultSprintId?) {
    for (const element of taskList) {
      if (element.defaulttask != '' && element.defaulttask != undefined && element.defaulttask != null) {

        let taskClass = this.parseService.instance.Object.extend('Tasks');
        var taskDetail = new taskClass();
        taskDetail.set('taskRole', []);
        taskDetail.set('dueDate', new Date());
        taskDetail.set('startDate', new Date());
        taskDetail.set('isActive', true);
        taskDetail.set('title', element.defaulttask);
        taskDetail.set('Project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
        taskDetail.set('taskCheckList', []);
        taskDetail.set('cardType', 'Backlog');
        taskDetail.set('description', element.defaulttask);
        taskDetail.set('comments', []);
        taskDetail.set('taskType', ['Medium']);
        taskDetail.set('typeOfTask', ["Task"]);
        taskDetail.set('attachments', []);
        taskDetail.set('priority', '');
        taskDetail.set('activities', []);
        taskDetail.set('idAttachmentCover', '');
        taskDetail.set('storyPoints', '');
        taskDetail.set('estimatedHours', 3600);
        taskDetail.set('completedHours', 0);
        taskDetail.set('syncTime', 0);
        taskDetail.set('taskStatus', 'Not yet Started');
        taskDetail.set('isAllocated', false);
        taskDetail.set('assigneesId', [this.profileId]);
        taskDetail.set('cardNumber', Number(this.getRandomNumber(4)));
        taskDetail.set('tenantId', this.tenantId);
        taskDetail.set('userPlannedStatus', 'new');
        taskDetail.set('storyPoints', '');
        taskDetail.set('taskUpdatedTime', {
          "todoDate": "",
          "inProgressDate": "",
          "completedDate": "",
          "readyForQaDate": "",
          "reOpenDate": "",
          "closedDate": ""
        });
        taskDetail.set('sprintId', { __type: 'Pointer', className: 'Sprint', objectId: defaultSprintId });
        taskDetail.set('scrumboardList', { __type: 'Pointer', className: 'ProjectBoardLists', objectId: scrumBoardId });
        taskDetail.set('todoDateActivity', []);
        taskDetail.set('inProgressDateActivity', []);
        taskDetail.set('completedDateActivity', []);
        taskDetail.set('readyForQaDateActivity', []);
        taskDetail.set('reOpenDateActivity', []);
        taskDetail.set('closedDateActivity', []);
        taskDetail.set('defaultTask', true);
        let data = await taskDetail.save();
        await this.addRelations(data.id);
        await this.projectBoardRelation(data)
      }
    }
  }

  async projectBoardRelation(taskData) {
    var queryRel = new this.parseService.instance.Query('ProjectBoardLists');
    queryRel.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    queryRel.equalTo('name', 'Backlogs');
    await queryRel.first().then((assignee) => {
      var relation = assignee.relation('Tasks');
      relation.add(taskData);
      assignee.save().then((result) => {
      });
    });
  }


  async addRelations(taskId) {
    var queryRel = new this.parseService.instance.Query('Tasks');
    queryRel.equalTo('objectId', taskId);
    await queryRel.first().then((assignee) => {
      var relation = assignee.relation('assignee');
      relation.add(this.profileDetail);
      assignee.save().then((result) => {
      });
      return assignee;
    });
  }

  async createEmployeeProfile(employeeList) {
    for (const element of employeeList) {
      let userClass = this.parseService.instance.Object.extend('_User');
      let userNameQuery = new this.parseService.instance.Query(userClass);
      userNameQuery.equalTo('username', element.name);
      let res = await userNameQuery.find();
      if (res.length > 0) {
        return;
      }

      let email = this.parseService.instance.Object.extend('_User');
      let emailQuery = new this.parseService.instance.Query(email);
      emailQuery.equalTo('email', element.email);
      let result = await emailQuery.find();
      if (result.length > 0) {
        return false;
      }

      let profile = this.parseService.instance.Object.extend('Profile');
      let createQuery = new profile();

      var role = new this.parseService.instance.Object('_Role');
      role.id = this.softwareEngineerRoleId;
      this.roleId = role.id;
      createQuery.set('role', role);
      var roleHistory = [];
      var currentRole = this.roleList.filter(
        role => role.id == this.softwareEngineerRoleId
      );
      let roleHistoryInfo = {
        id: 'pfBmtj09sE',
        name: 'Software Engineer',
        startDate: new Date(),
        endDate: '',
        isActive: true
      };
      roleHistory.push(roleHistoryInfo);
      createQuery.set('roleHistory', roleHistory);
      createQuery.set('firstName', '');
      createQuery.set('lastName', '');
      createQuery.set('username', element.name);
      createQuery.set('email', element.email);
      createQuery.set('password', 'openworx@098');
      createQuery.set('isActive', true);
      createQuery.set('isLongLeave', false);
      createQuery.set('departmentHistory', []);
      createQuery.set('locationHistory', []);
      createQuery.set('organisationHistory', []);
      createQuery.set('reporterHistory', []);
      createQuery.set('personalInfo', { 'mobileNo': '' });
      createQuery.set('skillSet', []);
      createQuery.set('resignationInfo', {});
      createQuery.set('profileImageInfo', {});
      createQuery.set('officialInfo', { 'startTime': '9:30 AM', 'officialEmail': element.email });
      createQuery.set('systemInfo', {});
      createQuery.set('experienceInfo', []);
      createQuery.set('userStatus', 'Away');
      createQuery.set('tenantId', this.tenantId);
      createQuery.set('screenShot', true);
      createQuery.set('screenShotSyncTime', 300);
      localStorage.clear();
      sessionStorage.clear();
      createQuery.save().then((data) => {
        let profileId = data.id;
        this.createEmployeeUser(element);
        this.createEmployeeCustomAccess(profileId);
        this.sendEmployeeRegisterAccountEmail(data);
      }).catch((error) => {
        if (error.message === 'Account already exists for this username.') {
          return false;
        } else if (error.message === 'Account already exists for this email address.') {
          return false;
        }
      });
    }
  }

  createEmployeeUser(element) {
    let user = this.parseService.instance.Object.extend('User');
    let createQuery = new user();
    let profile = this.parseService.instance.Object.extend('Profile');
    let profileClass = new profile();
    profileClass.id = this.profileId
    createQuery.set('profile', profileClass);
    createQuery.set('firstName', '');
    createQuery.set('lastName', '');
    createQuery.set('username', element.userName);
    createQuery.set('email', element.email);
    createQuery.set('password', 'SmartWork@123');
    createQuery.set('isActive', true);
    createQuery.set('employeeId', '');
    createQuery.set('tenantId', this.tenantId);
    createQuery.set('role', { __type: 'Pointer', className: '_Role', objectId: 'pfBmtj09sE' });
    createQuery.signUp().then((data) => {
      this.newId = data.id;
      this.addUsertoRoleNamed();
    }).catch((error) => {
      if (error.message === 'Account already exists for this username.') {
        this.toastr.error('Account already exists for this username.');
      } else if (error.message === 'Account already exists for this email address.') {
        this.toastr.error('Account already exists for this email address.');
      }
    });
  }

  async createEmployeeCustomAccess(profileId) {
    let CustomRoleSettings = this.parseService.instance.Object.extend('CustomRoleSettings');
    let createQuery = new CustomRoleSettings();
    createQuery.set('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId });
    let emploeeSettings = [
      {
        moduleName: "Employees",
        All: false,
        Assigned: true,
        None: false,
      },
      {
        moduleName: "Projects",
        All: false,
        Assigned: true,
        None: false,
      }
    ]
    createQuery.set('customRoles', emploeeSettings);
    createQuery.set('tenantId', this.tenantId);
    let data = await createQuery.save();
  }

  sendEmployeeRegisterAccountEmail(result) {

    let data = {
      name: result.get('firstName') + ' ' + result.get('lastName'),
      email: result.get('officialInfo').officialEmail,
      password: 'SmartWork@123'
    }
    this.dataService.add(this.configuration.registerAccount, data).subscribe((data: any) => {
    });
  }

  //Default Assigned Project for Admin
  async assignProject(res) {
    let ProjectClass = this.parseService.instance.Object.extend('ProjectMembers');
    var projectDetails = new ProjectClass();
    projectDetails.set('project', { __type: 'Pointer', className: 'Project', objectId: res.id });
    projectDetails.set('startDate', new Date());
    projectDetails.set('endDate', new Date());
    projectDetails.set('resourcesType', res.attributes.projectInfo.projectType);
    projectDetails.set('username', this.profileUserName);
    projectDetails.set('isActive', true);
    projectDetails.set('isInvited', false);
    projectDetails.set('status', 'Assigned');
    // if (this.formfirstStep.value.industry.industry == 'BPO') {
    projectDetails.set('role', '');
    // }
    // else {
    //   projectDetails.set('role', 'PM');
    // }
    projectDetails.set('Hours', 0);
    projectDetails.set('Month', 0);
    projectDetails.set('tenantId', this.tenantId);
    projectDetails.set('user', { __type: 'Pointer', className: '_User', objectId: this.newId });
    let projectMember = await projectDetails.save();
    return projectMember;
  }

  async invitedUser() {
    for (let data of this.invitePpls) {
      this.invitedUserEmail = data.email;
      var name = data.email.substring(0, data.email.lastIndexOf("@"));
      this.invitedUserName = name;

      let user = this.parseService.instance.Object.extend('_User');
      let userDetials = new this.parseService.instance.Query(user);
      userDetials.equalTo('email', this.invitedUserEmail);
      let admin = await userDetials.find();
      if (admin.length > 0) {
        this.toastr.warning("Account already exists for this Invited User.");
      }

      else if (admin.length == 0) {
        let profile = this.parseService.instance.Object.extend('Profile');
        let createQuery = new profile();
        createQuery.set('firstName', this.invitedUserName);
        createQuery.set('lastName', this.invitedUserName);
        createQuery.set('username', this.invitedUserName);
        createQuery.set('email', this.invitedUserEmail);
        createQuery.set('screenShot', true);
        createQuery.set('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
        createQuery.set('password', 'SmartWork@123');
        createQuery.set('isActive', true);
        createQuery.set('isLongLeave', false);
        createQuery.set('departmentHistory', []);
        createQuery.set('locationHistory', []);
        createQuery.set('organisationHistory', []);
        createQuery.set('reporterHistory', []);
        createQuery.set('personalInfo', { 'mobileNo': '' });
        createQuery.set('skillSet', []);
        createQuery.set('resignationInfo', {});
        createQuery.set('profileImageInfo', {});
        createQuery.set('officialInfo', { 'startTime': '9:30 AM', 'officialEmail': this.invitedUserEmail });
        createQuery.set('systemInfo', {});
        createQuery.set('experienceInfo', []);
        createQuery.set('userStatus', 'Away');
        createQuery.set('status', 'Pending');
        createQuery.set('screenShotSyncTime', 300);
        createQuery.set('tenantId', this.tenantId);
        // createQuery.set('isWebDesktop', data.isWebDesktop); // set desktop setting for individual user
        createQuery.set('isWebDesktop', this.formfirstStep.value.isWebDesktop);
        var location = new this.parseService.instance.Object('Location');
        location.id = this.locationId;
        createQuery.set('location', location);
        var organisation = new this.parseService.instance.Object('Organisation');
        organisation.id = this.organizationId;
        createQuery.set('organisation', organisation);
        var department = new this.parseService.instance.Object('Department');
        department.id = this.departmentList[1].objectId;;
        createQuery.set('department', department);
        // Role Info
        var roleHistory = [];
        let roleHistoryInfo = {
          id: 'pfBmtj09sE',
          name: 'Software Engineer',
          startDate: new Date(),
          endDate: '',
          isActive: true
        };
        roleHistory.push(roleHistoryInfo);
        createQuery.set('roleHistory', roleHistory);
        var role = new this.parseService.instance.Object('_Role');
        role.id = "pfBmtj09sE";
        this.roleId = role.id;
        createQuery.set('role', role);
        localStorage.clear();
        sessionStorage.clear();
        var result = await createQuery.save();
        this.invitedProfileId = result.id;
        await this.createInvitedUser(this.invitedProfileId);
        await this.createInviteCustomAccess(this.invitedProfileId);
      }
    }
  }

  async createInvitedUser(profileId) {
    let user = this.parseService.instance.Object.extend('User');
    let createQuery = new user();
    let profile = this.parseService.instance.Object.extend('Profile');
    let profileClass = new profile();
    profileClass.id = profileId
    createQuery.set('profile', profileClass)
    createQuery.set('firstName', this.invitedUserName);
    createQuery.set('lastName', this.invitedUserName);
    createQuery.set('username', this.invitedUserName);
    createQuery.set('email', this.invitedUserEmail);
    createQuery.set('password', 'SmartWork@123');
    createQuery.set('isActive', true);
    createQuery.set('employeeId', '');
    createQuery.set('tenantId', this.tenantId);
    createQuery.set('role', { __type: 'Pointer', className: '_Role', objectId: 'pfBmtj09sE' });
    var result = await createQuery.signUp();
    this.invitedUserId = result.id;
    this.invitedUsers = result.attributes.username;
    await this.addInvitedUsertoRoleNamed(this.invitedUserId);
    if (this.assignProjectToUser === true) {
      await this.InvitedUserProjectAssigned(this.profileDetails, this.invitedUserId);
      await this.defaultTasksInvitedUser(this.filtersFormArray.value, this.invitedProfileId);
    }
    await this.InvitedUserProjectAssigned(this.unassingedProjectDetails, this.invitedUserId);
  }

  async addInvitedUsertoRoleNamed(userId) {
    var queryRel = new this.parseService.instance.Query('User');
    queryRel.equalTo('objectId', userId);
    await queryRel.find().then(users => {
      var user = users[0];
      this.addInviteRelation(user).then(res => {
      });
    }).then((error) => {
    })
  }

  async addInviteRelation(user) {
    var queryRel = new this.parseService.instance.Query('_Role');
    queryRel.equalTo('objectId', this.roleId);
    await queryRel.first().then((role) => {
      var relation = role.relation('users');
      relation.add(user);
      role.save().then((result) => {
      });
      return role;
    });
  }

  async createInviteCustomAccess(profileId) {
    let CustomRoleSettings = this.parseService.instance.Object.extend('CustomRoleSettings');
    let createQuery = new CustomRoleSettings();
    createQuery.set('tenantId', this.tenantId);
    createQuery.set('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId });
    let emploeeSettings = [
      {
        moduleName: "Employees",
        All: false,
        Assigned: true,
        None: false,
      },
      {
        moduleName: "Projects",
        All: false,
        Assigned: true,
        None: false,
      }
    ];
    createQuery.set('customRoles', emploeeSettings);
    createQuery.set('tenantId', this.tenantId);
    await createQuery.save();
  }

  async InvitedUserProjectAssigned(res, invitedUserId) {
    let ProjectClass = this.parseService.instance.Object.extend('ProjectMembers');
    var projectDetails = new ProjectClass();
    projectDetails.set('project', { __type: 'Pointer', className: 'Project', objectId: res.id });
    projectDetails.set('startDate', new Date());
    projectDetails.set('endDate', new Date());
    projectDetails.set('resourcesType', res.attributes.projectInfo.projectType);
    projectDetails.set('username', this.invitedUsers);
    projectDetails.set('isActive', true);
    projectDetails.set('isInvited', true);
    projectDetails.set('status', 'Assigned');
    // if (this.formfirstStep.value.industry.industry == 'BPO') {
    projectDetails.set('role', '');
    // }
    // else {
    //   projectDetails.set('role', 'Full Stack');
    // }
    projectDetails.set('tenantId', this.tenantId);
    projectDetails.set('Hours', 0);
    projectDetails.set('Month', 0);
    projectDetails.set('user', { __type: 'Pointer', className: '_User', objectId: invitedUserId });
    let projectMember = await projectDetails.save();
    return projectMember;
  }

  async addLocation() {
    let locationClass = this.parseService.instance.Object.extend('Location');
    var locationDetails = new locationClass();
    locationDetails.set('name', 'Default Location');
    locationDetails.set('isActive', true);
    locationDetails.set('tenantId', this.tenantId);
    locationDetails.set('createdBy', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    let data = await locationDetails.save();
    this.locationId = data.id;
  }

  // Add Organization
  async addOrganization() {
    let formData = {
      name: 'Default Organization',
      email: this.formfirstStep.controls.email.value
    }
    let organizationClass = this.parseService.instance.Object.extend('Organisation');
    var organizationDetails = new organizationClass();
    organizationDetails.set('name', 'Default Organization');
    organizationDetails.set('email', this.formfirstStep.controls.email.value);
    organizationDetails.set('data', formData);
    organizationDetails.set('isActive', true);
    organizationDetails.set('tenantId', this.tenantId);
    organizationDetails.set('createdBy', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    let data = await organizationDetails.save();
    this.organizationId = data.id;
  }

  async addDepartment() {
    let departmentClass = this.parseService.instance.Object.extend('Department');
    var departmentDetails = new departmentClass();
    departmentDetails.set('name', 'Full Stack');
    departmentDetails.set('isActive', true);
    departmentDetails.set('tenantId', this.tenantId);
    departmentDetails.set('createdBy', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    let data = await departmentDetails.save();
    this.departmentId = data.id;
  }

  async defaultTasksInvitedUser(taskList, profileId) {
    for (const element of this.filtersFormArray.value) {
      if (element.defaulttask != '' && element.defaulttask != undefined && element.defaulttask != null) {
        let taskClass = this.parseService.instance.Object.extend('Tasks');
        var taskDetail = new taskClass();
        taskDetail.set('dueDate', new Date());
        taskDetail.set('startDate', new Date());
        taskDetail.set('isActive', true);
        taskDetail.set('title', element.defaulttask);
        taskDetail.set('Project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
        taskDetail.set('taskCheckList', []);
        taskDetail.set('cardType', 'Backlog');
        taskDetail.set('description', element.defaulttask);
        taskDetail.set('comments', []);
        taskDetail.set('taskRole', []);
        taskDetail.set('taskType', ['Medium']);
        taskDetail.set('typeOfTask', ["Task"]);
        taskDetail.set('attachments', []);
        taskDetail.set('priority', '');
        taskDetail.set('activities', []);
        taskDetail.set('idAttachmentCover', '');
        taskDetail.set('storyPoints', '');
        taskDetail.set('estimatedHours', 3600);
        taskDetail.set('completedHours', 0);
        taskDetail.set('syncTime', 0);
        taskDetail.set('taskStatus', 'Not yet Started');
        taskDetail.set('isAllocated', false);
        taskDetail.set('assigneesId', [profileId]);
        taskDetail.set('cardNumber', Number(this.getRandomNumber(4)));
        taskDetail.set('tenantId', this.tenantId);
        taskDetail.set('sprintId', { __type: 'Pointer', className: 'Sprint', objectId: this.defaultSprintId });
        taskDetail.set('scrumboardList', { __type: 'Pointer', className: 'ProjectBoardLists', objectId: this.scrumBoardId });
        taskDetail.set('userPlannedStatus', 'new');
        taskDetail.set('taskUpdatedTime', {
          "todoDate": "",
          "inProgressDate": "",
          "completedDate": "",
          "readyForQaDate": "",
          "reOpenDate": "",
          "closedDate": ""
        });
        taskDetail.set('todoDateActivity', []);
        taskDetail.set('inProgressDateActivity', []);
        taskDetail.set('completedDateActivity', []);
        taskDetail.set('readyForQaDateActivity', []);
        taskDetail.set('reOpenDateActivity', []);
        taskDetail.set('closedDateActivity', []);
        taskDetail.set('defaultTask', true);
        let data = await taskDetail.save();
        await this.addRelations(data.id);
        await this.projectBoardRelation(data)
      }
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  async addClient() {
    let data = {
      companyInfo: {
        firstName: this.formfirstStep.value.firstName,
        lastName: this.formfirstStep.value.lastName,
        companyName: "Default Company",
        companyAddress: "Default Address",
        companyPhoneNo: this.formfirstStep.value.mobileNumber,
        emailAddress: this.formfirstStep.value.email,
        currency: "USD"
      },
      contactInfo: {
        pickTime: "09:30 PM",
        preferredContactTime: "01:30 PM",
        websiteURL: "http://35.180.216.134/marketing",
        facebookURL: "",
        skypeURL: "",
        twitterURL: ""
      }
    };
    let ClientClass = this.parseService.instance.Object.extend('Client');
    var clientDetails = new ClientClass();
    clientDetails.set('companyInfo', data.companyInfo);
    clientDetails.set('contactInfo', data.contactInfo);
    clientDetails.set('tenantId', this.tenantId);
    let clientResult = await clientDetails.save();
    this.clientId = clientResult.id;
  }

  getDepartment() {
    const DepartmentClass = this.parseService.instance.Object.extend('Department');
    const departmentQuery = new this.parseService.instance.Query(DepartmentClass);
    departmentQuery.equalTo('isActive', true);
    departmentQuery.find().then((departments) => {
      const department = JSON.parse(JSON.stringify(departments));
      this.departmentList = department;
    });
  }

}
